function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(16).padStart(8, '0');
}

function simplifyUa(ua) {
  const browserMatch = ua.match(/(Edg|Chrome|Firefox|Safari)\/(\d+)/);
  const osMatch = ua.match(/(Windows NT \d+\.\d+|Mac OS X \d+[._]\d+|Linux)/);
  const browser = browserMatch ? `${browserMatch[1]}/${browserMatch[2]}` : '';
  const os = osMatch ? osMatch[1].replace(/_/g, '.') : '';
  return `${browser}|${os}`;
}

function getWebGLInfo() {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) return { vendor: '', renderer: '' };
    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
    if (debugInfo) {
      return {
        vendor: gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) || '',
        renderer: gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || '',
      };
    }
    return { vendor: '', renderer: '' };
  } catch (e) {
    return { vendor: '', renderer: '' };
  }
}

function getCanvasFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    canvas.width = 280;
    canvas.height = 60;
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';

    // 绘制背景
    ctx.fillStyle = '#f0f7ff';
    ctx.fillRect(0, 0, 280, 60);

    // 绘制文字（使用特定字体和大小，不同系统渲染有差异）
    ctx.font = '18px Arial, Helvetica, sans-serif';
    ctx.fillStyle = '#1677ff';
    ctx.fillText('Welzek FP v2', 10, 28);

    ctx.font = '14px "Microsoft YaHei", sans-serif';
    ctx.fillStyle = '#595959';
    ctx.fillText('为准电子', 10, 50);

    // 绘制几何图形
    ctx.beginPath();
    ctx.arc(240, 30, 15, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(22, 119, 255, 0.3)';
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(200, 10);
    ctx.lineTo(220, 50);
    ctx.lineTo(180, 50);
    ctx.closePath();
    ctx.fillStyle = 'rgba(255, 77, 79, 0.4)';
    ctx.fill();

    const dataUrl = canvas.toDataURL('image/png');
    return hashString(dataUrl);
  } catch (e) {
    return '';
  }
}

export function getDeviceFingerprint() {
  const webgl = getWebGLInfo();
  const canvasFp = getCanvasFingerprint();
  const components = [
    simplifyUa(navigator.userAgent),
    navigator.platform,
    navigator.hardwareConcurrency || '',
    navigator.maxTouchPoints || 0,
    webgl.vendor,
    webgl.renderer,
    canvasFp,
  ];
  return hashString(components.join('###'));
}

export function getDeviceInfo() {
  const ua = navigator.userAgent;
  const webgl = getWebGLInfo();
  let browser = 'Unknown';
  let os = 'Unknown';

  if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('Chrome/')) browser = 'Chrome';
  else if (ua.includes('Firefox/')) browser = 'Firefox';
  else if (ua.includes('Safari/') && !ua.includes('Chrome')) browser = 'Safari';

  if (ua.includes('Windows NT 10.0')) os = 'Windows 10/11';
  else if (ua.includes('Windows NT 6.1')) os = 'Windows 7';
  else if (ua.includes('Mac OS X')) os = 'macOS';
  else if (ua.includes('Linux')) os = 'Linux';

  return {
    fingerprint: getDeviceFingerprint(),
    browser,
    os,
    platform: navigator.platform || '',
    cpuCores: navigator.hardwareConcurrency || '',
    memory: navigator.deviceMemory || '',
    maxTouchPoints: navigator.maxTouchPoints || 0,
    webglVendor: webgl.vendor,
    webglRenderer: webgl.renderer,
    canvasFp: getCanvasFingerprint(),
  };
}
